import { useSelector } from "react-redux";
import { getPopulationRate, getThemeSelectedValue } from "../../../reducer/morbidityRateSlice";
import { Grid, Typography } from "@mui/material";

function MorbidityLegend(props) {
    const themeMorbidity = useSelector(getThemeSelectedValue);
    const populationValue = useSelector(getPopulationRate);

    return (
        <>
            <div style={{
                position: 'relative'
            }}>
                <Typography sx={{ 
                    fontSize: 12, 
                    textAlign: 'left',
                    fontWeight: '400',
                }}>
                    อัตราป่วยต่อประชากร {populationValue.toLocaleString()} คน
                </Typography>
                <Grid container spacing={0}>
                {
                    themeMorbidity.map((data, index) => {
                        return (
                            <Grid key={index} item xs={(12/themeMorbidity.length)}>
                                <div style={{
                                    height: 20,
                                    backgroundColor: data.color,
                                    marginTop: '5px'
                                }}></div>
                                <Typography sx={{
                                    fontSize: 10,
                                    textAlign: 'center',
                                    marginTop: '5px',
                                    fontWeight: '400',
                                }}>
                                    {data.legend}
                                </Typography>
                            </Grid>
                        )
                    })
                }
                </Grid>
            </div>
        </>
    )
}

export default MorbidityLegend;